import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { IErrorObject } from "../models/error.interface";
@Injectable({ providedIn: "root" })
export class ErrorService {
  private errors = new Subject<IErrorObject>();

  public logError(error: string, _message: string) {
    this.errors.next({ orignalError: error, message: _message });
  }

  public clearError() {
    this.errors.next(undefined);
  }

  public getError(): Observable<IErrorObject> {
    return this.errors.asObservable();
  }
}
